/**
 * Cart Page Fixes - Ensure proper mobile display
 * This script ensures the cart displays correctly on mobile devices
 *
 * Moved here from raftor_webhq: this is visual/layout behavior for the
 * /cart page, and raftor_websitehq owns 100% of that rendering (see
 * rfhq_cart.css's own header) -- raftor_webhq owns zero visual code.
 */

frappe.ready(function () {
	// Only run on cart page
	if (!window.location.pathname || !window.location.pathname.startsWith("/cart")) {
		return;
	}

	// Wait for DOM to be fully loaded
	setTimeout(function() {
		fixCartDisplay();
		fixCartAddressDisplay();
	}, 500);

	// Also fix on any dynamic updates
	if (window.jQuery && typeof window.jQuery === "function") {
		window.jQuery(document).on("cart-updated", function () {
			setTimeout(function () {
				fixCartDisplay();
				fixCartAddressDisplay();
			}, 300);
		});
	}
});

function fixCartDisplay() {
	// On mobile, ensure proper layout
	if (window.innerWidth < 768) {
		// The row-by-row inline display:block this used to set here is gone --
		// it beat rfhq_templates.css's own @media (max-width: 992px) rules
		// (an inline style wins over any non-!important stylesheet rule
		// regardless of specificity), silently forcing every cart line item
		// back to a bare block stack no matter what that CSS tried to compose
		// instead. That CSS now owns the mobile card layout entirely
		// (image+title row, qty+price row, a re-shown remove icon) -- this
		// function only needs to still guard against horizontal scroll.

		// Ensure container doesn't cause horizontal scroll
		const containers = document.querySelectorAll('.cart-container, .page-content-wrapper, .container');
		containers.forEach(function(container) {
			container.style.overflowX = 'hidden';
			container.style.maxWidth = '100vw';
		});
	}
}

function fixCartAddressDisplay() {
	// Ensure address sections are visible
	const addressSelectors = [
		'[data-section="shipping-address"]',
		'[data-section="billing-address"]',
		'.shipping-address',
		'.billing-address',
		'.cart-payment-addresses'
	];

	addressSelectors.forEach(function(selector) {
		const elements = document.querySelectorAll(selector);
		elements.forEach(function(el) {
			if (el) {
				el.style.display = 'block';
				el.style.visibility = 'visible';
				el.style.opacity = '1';
			}
		});
	});
}

// Re-run fixes on window resize (debounced)
let resizeTimer;
window.addEventListener('resize', function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		if (window.location.pathname && window.location.pathname.startsWith("/cart")) {
			fixCartDisplay();
		}
	}, 250);
});
